import { typeAlias } from "@babel/types"
import { Modal } from "react-bootstrap"
import { IHangUpReasonOutputs, IOutPut } from "../../../../api/resultAPI/resendInvoiceResponse"
import { useEffect } from "react"
import '../../style.scss'
import { ToPersianNumber } from "../../../../functions"


type Props = {
    setShowHistory: Function,
    showHistory: boolean,
    item: IOutPut
}

const History = ({
    setShowHistory,
    showHistory,
    item
}: Props) => {


    const handleClose = () => {
        setShowHistory(false)
    }
    return (
        <div>
            <Modal show={showHistory} onHide={handleClose} animation={true} dir="rtl" className="invoice-modal price-modal">
                <Modal.Header>
                    <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                        تاریخچه ی خط
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className='invoice-modal-content-view'>
                    {item?.hangUpReasonOutputs?.map((item: IHangUpReasonOutputs, index) =>
                        <div className="history-show">
                            <div className="d-flex justify-content-between title-reason">
                                <span className="">ردیف</span>
                                <span className="reason">دلیل ناموفق بودن تماس</span>
                                <span className="d-flex justify-content-center  title">تعداد تکرار</span>
                            </div>
                            <hr/>
                            <div className="d-flex justify-content-between">
                                <span className="d-flex justify-content-center  ">{ToPersianNumber(index + 1)} </span>
                                <span className="d-flex justify-content-center reason">{item?.callHangupReason}</span>
                                <span className="d-flex justify-content-center title">{ToPersianNumber(item?.hangUpCount)}</span>
                            </div>
                            <hr/>
                        </div>
                       

                    )}

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default History